import React from 'react';
import { Link } from 'react-router-dom';
import styles from './build-mirrored-in-tooltip.module.scss';

/**
 * Build the "Mirrored in" badge tooltip content from the targets list + the
 * KNOWLEDGE_CATEGORY lang block.
 *
 * Layout:
 *   Mirrored in:
 *   Workspace A / Cardiology / Unit A        ← clickable link
 *   Workspace B / Cardiology / Unit B / Unit C
 *
 * Each path line is a `react-router-dom` `<Link>` with `color: inherit` so it
 * picks up the tooltip's white text color. We don't use the design-system
 * `LinkButton` here because its visual is intentionally button-y (bold,
 * primary-color, margin-bottom) and doesn't fit inline tooltip text.
 *
 * `white-space: nowrap` on each line is paired with `overlayInnerStyle.maxWidth`
 * on the surrounding Tooltip (see MirrorBadge source variant) so each path
 * stays on a single line and the tooltip widens to fit the longest path.
 *
 * Click propagation is stopped so the surrounding card/row click handler
 * doesn't fire.
 *
 * @param {Array<{ workspaceName: string, pathTitles: string[], link: string }>} targets
 * @param {object} lang - the KNOWLEDGE_CATEGORY lang block
 * @returns {React.ReactNode}
 */
export function buildMirroredInTooltip(targets, lang) {
  return (
    <>
      <span className={styles.line}>{lang.MIRRORED_IN_TARGETS_PREFIX}</span>
      {targets.map((target, i) => (
        <span key={i} className={styles.line}>
          <Link
            to={target.link}
            className={styles.link}
            onClick={e => e.stopPropagation()}>
            {target.workspaceName} / {target.pathTitles.join(' / ')}
          </Link>
        </span>
      ))}
    </>
  );
}
